import { getUserTag as getUserTagApi } from '../../api/from-traffic/userApi';

export function getUserTag() {
    return getUserTagApi().catch(e => {
        console.error('getUserTag error', e);
        return {
            data: {
                usertag: 'ERROR'
            }
        };
    });
}



// WEBPACK FOOTER //
// ./src/api-computed/from-traffic/userApi.js